import i18next from 'i18next';
import React from 'react';

import { DropdownItem, DropdownItemSubTitle, DropdownItemTitle } from './styledComponents';

const StoresWithActiveProperty = ({ name, active }) => (
  <DropdownItem>
    <DropdownItemTitle>{name}</DropdownItemTitle>
    <DropdownItemSubTitle>
      {i18next.t(active ? 'GENERAL.ACTIVE' : 'GENERAL.INACTIVE')}
    </DropdownItemSubTitle>
  </DropdownItem>
);

export default StoresWithActiveProperty;
